/* @ngInject */

export default function AddFromCategoryCtrl (Shelf, contentType, pckgId, $uibModalInstance) {
  const vm = this

  vm.isLoading = true
  vm.selectedCategory = null

  Shelf._getCategories(pckgId, { contentType })
    .to(vm.categories = [])
    .then(() => { vm.isLoading = false })

  vm.addFromCategory = function () {
    if (vm.selectedCategory) {
      $uibModalInstance.close(vm.selectedCategory)
    }
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/addContentSets.controller:AddFeaturedRowItemsCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
